/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Action_Dfsm_WebInputs */

const en_colleague_action_dfsm_web = /** @type {(inputs: Colleague_Action_Dfsm_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DFSM Web`)
};

const ja_colleague_action_dfsm_web = /** @type {(inputs: Colleague_Action_Dfsm_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DFSM Web`)
};

const fr_colleague_action_dfsm_web = /** @type {(inputs: Colleague_Action_Dfsm_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DFSM Web`)
};

const de_colleague_action_dfsm_web = /** @type {(inputs: Colleague_Action_Dfsm_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DFSM Web`)
};

/**
* | output |
* | --- |
* | "DFSM Web" |
*
* @param {Colleague_Action_Dfsm_WebInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_action_dfsm_web = /** @type {((inputs?: Colleague_Action_Dfsm_WebInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Action_Dfsm_WebInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_action_dfsm_web(inputs)
	if (locale === "ja") return ja_colleague_action_dfsm_web(inputs)
	if (locale === "fr") return fr_colleague_action_dfsm_web(inputs)
	return de_colleague_action_dfsm_web(inputs)
});